export default "__VITE_ASSET__1d19bc11__"